/* eslint-disable default-case */
import { COUNSELING_CATEGORY_TYPES } from "../../constants/COUNSELING";
import CounselingDetail from "../../pages/Counseling/CounselingDetail";
import React from 'react';
import { isEmpty } from "../lodashExtend";
import Profile from "../../components/Profile";
import Icon from "../../components/Icon";
import CommentIcon from "../../assets/images/icon/comment-icon.svg";
import store from "../../store";
import http from "../http";
import { translation } from "../translator";
import { BANK_DATA } from "../../constants/BANK_DATA";

export const taxPortalCounselingList = (params) => {
  const companyIdx = store?.getState()?.Profile?.company?.managerCompanyIdx;
  return new Promise((resolve, reject) => {
    http
      .post(`/counseling/manager/all/list/${companyIdx}`, params)
      .then((res) => {
        const { total, metadata, counselings, comment } = res.data;
        resolve({
          count: total,
          list: !isEmpty(counselings) ? counselings.map((post, index) => ({
            ...post,
            count: total - metadata.offset - index,
            comments: comment.listByPost.find(c => c.postIdx === post.idx) || {}
          })) : [],
        });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const taxPortalBankAccountList = (params) => {
  return new Promise((resolve, reject) => {
    http
      .get("/banks/accounts", {
        params: {
          includeDeleted: false,
          type: 'normal_account',
          idx: params.bankAccountIdx || null,
          status: 'enabled',
          companyIdx: params.companyIdx
        },
      })
      .then((res) => {
        const bankAccountList = res.data.bankAccounts.map((bank) => ({
          ...bank,
          bankCompany: translation(BANK_DATA, bank.bankCd, "fcode", "name"),
          bankImg: translation(
            BANK_DATA,
            bank.bankCd,
            "fcode",
            "bankImg"
          ),
        }));

        resolve({ list: bankAccountList });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const USE_CONFIRM_TYPES = ['useConfirms', 'mappingAndUseConfirms', 'categoryMappingAndUseConfirms'];
export const BANK_KEYS = ['mappings', 'mappingAndUseConfirms', 'useConfirms', 'categoryMappings'];

export const getCompaniesDetail = async (key, params) => {
  let accountList = [];
  if (BANK_KEYS.includes(key)) {
    const res = await http.get("/banks/accounts", {
      params: {
        includeDeleted: false,
        type: 'normal_account',
        idx: null,
        status: 'enabled',
        companyIdx: params.companyIdx
      },
    });
    if (!isEmpty(res.data.bankAccounts)) {
      var list = [];
      (res.data.bankAccounts || []).forEach((bank) => {
        if (bank.status === "enabled") {
          list.push({
            ...bank,
            bankCompany: translation(BANK_DATA, bank.bankCd, "fcode", "name"),
          });
        }
      });
      accountList = list;
    }
  }
  const detailData = {
    unreadCounselings: {
      api: taxPortalCounselingList,
      isOnSelect: true,
      detailComponent: (props) => {
        const htmlProps = {
          counseling: props.detailItem,
          setCounseling: props.setDetailItem,
          open: props.open,
          setOpen: props.setOpen,
          submit: props.submit,
          orgMode: props.mode,
        };
        return (
          <CounselingDetail {...htmlProps} counselingType="tax" />
        );
      },
      type: "table",
    },
    unreadCounselingToCompanies: {
      api: taxPortalCounselingList,
      isOnSelect: true,
      detailComponent: (props) => {
        const htmlProps = {
          counseling: props.detailItem,
          setCounseling: props.setDetailItem,
          open: props.open,
          setOpen: props.setOpen,
          submit: props.submit,
          orgMode: props.mode,
        };
        return (
          <CounselingDetail {...htmlProps} counselingType="tax" />
        );
      },
      type: "table",
    },
    // 매핑안된내역
    mappings: {
      api: taxPortalBankAccountList,
      bankParams: {
        noneRange: true,
        clientRegistered: true,
        inoutAmt: "0",
      },
      isOnSelect: false,
      isFilter: true,
      filters: [
        {
          title: "계좌선택",
          type: "select",
          key: "bankAccountIdx",
          options: {
            list: [
              { label: "전체", value: "" },
              ...accountList.map((bank) => ({
                label: `${bank.bankCompany}(${bank.accountNo.substr(bank.accountNo.length - 5)})`,
                value: bank.idx,
              })),
            ],
          },
        },
        {
          title: "입출금",
          type: "select",
          key: "checkingType",
          options: {
            list: [
              { label: "전체", value: "" },
              { label: "입금", value: "deposit" },
              { label: "출금", value: "withdraw" },
            ],
          },
        },
        {
          title: "입출금액",
          type: "input",
          key: "inoutAmt",
          placeholder: '금액 입력',
          validators: ['comma', 'positive'],
        },
        {
          title: "거래자명 검색",
          key: "search.traderName",
          placeholder: '거래자명 입력'
        },
      ],
      type: "bank_table"
    },
    categoryMappings: {
      api: taxPortalBankAccountList,
      bankParams: {
        noneRange: true,
        categoryRegistered: true,
        inoutAmt: "0",
      },
      isOnSelect: false,
      isFilter: true,
      filters: [
        {
          title: "계좌선택",
          type: "select",
          key: "bankAccountIdx",
          options: {
            list: [
              { label: "전체", value: "" },
              ...accountList.map((bank) => ({
                label: `${bank.bankCompany}(${bank.accountNo.substr(bank.accountNo.length - 5)})`,
                value: bank.idx,
              })),
            ],
          },
        },
        {
          title: "입출금",
          type: "select",
          key: "checkingType",
          options: {
            list: [
              { label: "전체", value: "" },
              { label: "입금", value: "deposit" },
              { label: "출금", value: "withdraw" },
            ],
          },
        },
        {
          title: "입출금액",
          type: "input",
          key: "inoutAmt",
          placeholder: '금액 입력',
          validators: ['comma', 'positive'],
        },
        {
          title: "거래자명 검색",
          key: "search.traderName",
          placeholder: '거래자명 입력'
        },
      ],
      type: "bank_table"
    },
    // 매핑안된내역 + 내역확인요청
    mappingAndUseConfirms: {
      api: taxPortalBankAccountList,
      bankParams: {
        noneRange: true,
        clientRegistered: true,
        inoutAmt: "0",
      },
      isOnSelect: false,
      isFilter: true,
      filters: [
        {
          title: "계좌선택",
          type: "select",
          key: "bankAccountIdx",
          options: {
            list: [
              { label: "전체", value: "" },
              ...accountList.map((bank) => ({
                label: `${bank.bankCompany}(${bank.accountNo.substr(bank.accountNo.length - 5)})`,
                value: bank.idx,
              })),
            ],
          },
        },
        {
          title: "입출금",
          type: "select",
          key: "checkingType",
          options: {
            list: [
              { label: "전체", value: "" },
              { label: "입금", value: "deposit" },
              { label: "출금", value: "withdraw" },
            ],
          },
        },
        {
          title: "입출금액",
          type: "input",
          key: "inoutAmt",
          placeholder: '금액 입력',
          validators: ['comma', 'positive'],
        },
        {
          title: "거래자명 검색",
          key: "search.traderName",
          placeholder: '거래자명 입력'
        },
      ],
      type: "bank_table"
    },
    categoryMappingAndUseConfirms: {
      api: taxPortalBankAccountList,
      bankParams: {
        noneRange: true,
        categoryRegistered: true,
        inoutAmt: "0",
      },
      isOnSelect: false,
      isFilter: true,
      filters: [
        {
          title: "계좌선택",
          type: "select",
          key: "bankAccountIdx",
          options: {
            list: [
              { label: "전체", value: "" },
              ...accountList.map((bank) => ({
                label: `${bank.bankCompany}(${bank.accountNo.substr(bank.accountNo.length - 5)})`,
                value: bank.idx,
              })),
            ],
          },
        },
        {
          title: "입출금",
          type: "select",
          key: "checkingType",
          options: {
            list: [
              { label: "전체", value: "" },
              { label: "입금", value: "deposit" },
              { label: "출금", value: "withdraw" },
            ],
          },
        },
        {
          title: "입출금액",
          type: "input",
          key: "inoutAmt",
          placeholder: '금액 입력',
          validators: ['comma', 'positive'],
        },
        {
          title: "거래자명 검색",
          key: "search.traderName",
          placeholder: '거래자명 입력'
        },
      ],
      type: "bank_table"
    },
    // 내역확인요청
    useConfirms: {
      api: taxPortalBankAccountList,
      bankParams: {
        noneRange: true,
      },
      isOnSelect: false,
      isFilter: true,
      filters: [
        {
          title: "계좌선택",
          type: "select",
          key: "bankAccountIdx",
          options: {
            list: [
              { label: "전체", value: "" },
              ...accountList.map((bank) => ({
                label: `${bank.bankCompany}(${bank.accountNo.substr(bank.accountNo.length - 5)})`,
                value: bank.idx,
              })),
            ],
          },
        },
        {
          title: "입출금",
          type: "select",
          key: "checkingType",
          options: {
            list: [
              { label: "전체", value: "" },
              { label: "입금", value: "deposit" },
              { label: "출금", value: "withdraw" },
            ],
          },
        },
        {
          title: "입출금액",
          type: "input",
          key: "inoutAmt",
          placeholder: '금액 입력',
          validators: ['comma', 'positive'],
        },
        {
          title: "거래자명 검색",
          key: "search.traderName",
          placeholder: '거래자명 입력'
        },
      ],
      type: "bank_table"
    },
  };

  return detailData[key];
};


export const getDetailFields = (type) => {

  const employee = store.getState()?.Profile.employee;
  let fields = [];
  switch (type) {
    case 'unreadCounselings':
    case 'unreadCounselingToCompanies':
      fields = [
        {
          title: "카테고리",
          className: 'text-align-left',
          key: "category",
          onValue: (value) => {
            return COUNSELING_CATEGORY_TYPES?.find((item) => Number(item.value) === Number(value))?.label;
          },
        },
        {
          title: "관리기업",
          className: 'text-align-left',
          key: "careCompany.name",
        },
        {
          title: "제목",
          className: 'text-align-left',
          key: "title",
          onValue: (value, _, d) => {
            const isNew = isEmpty(d.viewEmployee);

            const isUpdate = (d?.comments?.comments || []).find(f =>
              employee.employeeIdx === f.writerEmpIdx ? type === "unreadCounselingToCompanies" ? !f.isRead : false : !f.isRead
            );

            return (
              <>
                {value === 'null' || isEmpty(value) ? <span className="color-red-80">삭제된 게시글 입니다.</span> :
                  <span className={`font-bold`}>
                    {value}
                  </span>
                }

                {isNew ? !isEmpty(value) && <small className="color-red-100 font-size-10 ml-2 display-inline">new</small>
                  : !!isUpdate ? !isEmpty(value) && <small className="color-red-100 font-size-10 ml-2 display-inline">edited</small> : <></>
                }
              </>
            );
          },
        },
        {
          title: "주담당자",
          key: "managers",
          onValue: (data) => (data || []).filter(f => f.level === 1).map(item => item.employee?.name).join(',')
        },
        {
          title: "작성자",
          key: "writerEmployee",
          onValue: (data, fields, datas) => {
            return <Profile data={data} className={`${datas.isManagerWrite ? 'font-bold' : ''}`} />;
          }
        },
        { title: "작성일시", key: "createdTime", type: 'datetime' },
        {
          title: "읽은사람", key: "viewEmployee",
          onValue: (data, fields, datas) => {
            return data ? <Profile data={data} className={`${!datas.isManagerWrite ? 'font-bold' : ''}`} /> : '-';
          }
        },
        {
          title: '',
          key: 'comments',
          onValue: (value) => {
            return (
              !isEmpty(value) ? (
                <>
                  <Icon src={CommentIcon} />
                  <span className="ml-4 font-bold">{value.count}</span>
                </>
              ) : (<></>)
            );
          }
        },
      ];
      break;
    case 'mappings':
      // getManagerCounselingList
      break;
    case 'mappingAndUseConfirms':
      // getManagerCounselingList
      break;
    case 'useConfirms':
      // getManagerCounselingList
      break;
  }
  return fields;
};